export default "__VITE_ASSET__BQQY6D8Q__"